import AOS from 'aos';
import {initializeMobileMenu, desktopMenuHover} from './menu';
import frontpage from './frontpage';
import BlockCollapse from './blocks/collapse';
import BlockSliderBoxes from './blocks/slider-boxes';

import 'swiper/swiper-bundle.css';
import customSelect from './utils/customSelect';
import orders from './utils/orders';
import {checkboxStyle} from './utils/utils';

class App {
	constructor() {
		this.initialize();
	}

	initialize() {
		AOS.init(
			{
				disable: 'mobile',
				once: true,
				duration: 1000,
			},
		);
		desktopMenuHover();
		initializeMobileMenu();
		frontpage();
		BlockCollapse();
		BlockSliderBoxes();
		customSelect();
		orders();
		checkboxStyle();
	}
}

function initializeApp() {
	const app = new App();
}

if (document.readyState === 'loading') {
	document.addEventListener( 'DOMContentLoaded', initializeApp );
} else {
	initializeApp();
}
